(function () {
  'use strict';

  function initHeroGummies(section) {
    var stack = section.querySelector('[data-hg-stack]');
    var nextBtn = section.querySelector('[data-hg-next]');
    if (!stack || !nextBtn) return;

    var cards = Array.prototype.slice.call(stack.querySelectorAll('[data-hg-card]'));
    if (cards.length < 2) return;

    // `order` holds the cards in current front-to-back order.
    var order = cards.slice().sort(function (a, b) {
      return parseInt(a.dataset.hgPos, 10) - parseInt(b.dataset.hgPos, 10);
    });

    function applyOrder() {
      order.forEach(function (card, index) {
        card.dataset.hgPos = index;
      });
    }

    // Front card goes to the back; everyone else moves up one slot.
    function showNext() {
      order.push(order.shift());
      applyOrder();
    }

    // Back card comes to the front.
    function showPrev() {
      order.unshift(order.pop());
      applyOrder();
    }

    nextBtn.addEventListener('click', showNext);

    /* ---- Swipe / touch-drag ------------------------------------------ */

    // Browser keeps vertical scrolling; we only claim horizontal drags.
    stack.style.touchAction = 'pan-y';
    stack.style.cursor = 'grab';

    var SWIPE_MIN = 40;
    var startX = 0;
    var startY = 0;
    var tracking = false;

    stack.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      tracking = true;
      startX = event.clientX;
      startY = event.clientY;
      try {
        stack.setPointerCapture(event.pointerId);
      } catch (error) {
        // Older browsers - the swipe still works, it just needs to end on the stack.
      }
    });

    stack.addEventListener('pointerup', function (event) {
      if (!tracking) return;
      tracking = false;

      var dx = event.clientX - startX;
      var dy = event.clientY - startY;

      if (Math.abs(dx) < SWIPE_MIN) return;      // too small - treat it as a tap
      if (Math.abs(dx) <= Math.abs(dy)) return;  // mostly vertical - let the page scroll

      if (dx < 0) showNext();
      else showPrev();
    });

    // Fires when the browser takes over for a vertical scroll.
    stack.addEventListener('pointercancel', function () {
      tracking = false;
    });

    // Stop the browser's native image-drag from hijacking a mouse swipe.
    stack.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
  }

  function initAll() {
    document.querySelectorAll('.hero-gummies').forEach(initHeroGummies);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.hero-gummies');
    if (section) initHeroGummies(section);
  });
})();